// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb_breadcrumb__16h38","items":"breadcrumb_items__11K-i","item":"breadcrumb_item__1x__m","icon":"breadcrumb_icon__DIHw5"};